import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, Input, NgModule } from '@angular/core';
import * as i3 from 'base-generate-forms-library';
import { BaseGenerateFormsLibraryService } from 'base-generate-forms-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'reference-library';
import * as i6 from 'primeng/radiobutton';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PrimengLibraryModule } from 'primeng-library';

class OverrideRadioButtonLibraryService {
    constructor() { }
}
OverrideRadioButtonLibraryService.ɵfac = function OverrideRadioButtonLibraryService_Factory(t) { return new (t || OverrideRadioButtonLibraryService)(); };
OverrideRadioButtonLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: OverrideRadioButtonLibraryService, factory: OverrideRadioButtonLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverrideRadioButtonLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class OverrideRadioButtonLibraryComponent extends BaseGenerateFormsLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService, cRef) {
        super(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.referenceLibraryService = referenceLibraryService;
        this.cRef = cRef;
        this.generateUpload = new EventEmitter();
        // inputData:any;
        this.generateForms = true;
    }
    ngOnChanges() {
        this.inputData = this.primaryData;
        // var isGen = this.isGenerated;
        if (this.fileName !== undefined) {
            var obj;
            if (this.formType == 'primary' || this.formType == 'secondary' || this.formType == 'common') {
                obj = { key: this.fileName, isGenerate: this.isGenerated, formType: this.formType, currentIndex: this.currentIndex };
            }
            else if (this.formType == 'dependentForm') {
                obj = { key: this.fileName, isGenerate: this.isGenerated, formType: this.formType, currentIndex: this.currentIndex, subIndex: this.subIndex };
            }
            else {
                obj = { key: this.fileName, isGenerate: this.isGenerated };
            }
            this.generateForms = this.isGenerated;
            this.generateUpload.emit(obj);
        }
    }
    handleGenerateForm(value) {
        this.generateForms = value;
        var obj = {};
        if (this.formType == 'primary' || this.formType == 'secondary' || this.formType == 'common') {
            obj = { key: this.fileName, isGenerate: value, formType: this.formType, currentIndex: this.currentIndex };
        }
        else if (this.formType == 'dependentForm') {
            obj = { key: this.fileName, isGenerate: value, formType: this.formType, currentIndex: this.currentIndex, subIndex: this.subIndex };
        }
        else {
            obj = { key: this.fileName, isGenerate: value };
        }
        localStorage.setItem("overrideRadio" + this.fileName, JSON.stringify(obj));
        this.generateUpload.emit(obj);
        super.loadInit();
    }
}
OverrideRadioButtonLibraryComponent.ɵfac = function OverrideRadioButtonLibraryComponent_Factory(t) { return new (t || OverrideRadioButtonLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APIGenerateForms), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
OverrideRadioButtonLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: OverrideRadioButtonLibraryComponent, selectors: [["lib-override-radio-button-library"]], inputs: { primaryData: "primaryData", isGenerated: "isGenerated", isUploaded: "isUploaded", fileName: "fileName", formType: "formType", currentIndex: "currentIndex", subIndex: "subIndex" }, outputs: { generateUpload: "generateUpload" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 8, vars: 4, consts: [[1, "row"], [1, "col-6"], ["name", "generateForms", "label", "Generate Form", 1, "letter-radio", 3, "ngModel", "value", "onClick", "ngModelChange"], ["name", "generateForms", "label", "Upload Form", 1, "letter-radio", 3, "ngModel", "value", "onClick", "ngModelChange"], [1, "clearfix"]], template: function OverrideRadioButtonLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 0);
        i0.ɵɵelementStart(3, "p-radioButton", 2);
        i0.ɵɵlistener("onClick", function OverrideRadioButtonLibraryComponent_Template_p_radioButton_onClick_3_listener() { return ctx.handleGenerateForm(true); })("ngModelChange", function OverrideRadioButtonLibraryComponent_Template_p_radioButton_ngModelChange_3_listener($event) { return ctx.generateForms = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "div", 0);
        i0.ɵɵelementStart(6, "p-radioButton", 3);
        i0.ɵɵlistener("onClick", function OverrideRadioButtonLibraryComponent_Template_p_radioButton_onClick_6_listener() { return ctx.handleGenerateForm(false); })("ngModelChange", function OverrideRadioButtonLibraryComponent_Template_p_radioButton_ngModelChange_6_listener($event) { return ctx.generateForms = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.generateForms)("value", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.generateForms)("value", false);
    } }, directives: [i6.RadioButton, i7.NgControlStatus, i7.NgModel], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverrideRadioButtonLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-override-radio-button-library',
                templateUrl: 'override-radio-button-library.component.html',
                styleUrls: ['override-radio-button-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APIGenerateForms }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }]; }, { generateUpload: [{
            type: Output
        }], primaryData: [{
            type: Input
        }], isGenerated: [{
            type: Input
        }], isUploaded: [{
            type: Input
        }], fileName: [{
            type: Input
        }], formType: [{
            type: Input
        }], currentIndex: [{
            type: Input
        }], subIndex: [{
            type: Input
        }] }); })();

class OverrideRadioButtonLibraryModule {
}
OverrideRadioButtonLibraryModule.ɵfac = function OverrideRadioButtonLibraryModule_Factory(t) { return new (t || OverrideRadioButtonLibraryModule)(); };
OverrideRadioButtonLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: OverrideRadioButtonLibraryModule });
OverrideRadioButtonLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(OverrideRadioButtonLibraryModule, { declarations: [OverrideRadioButtonLibraryComponent], imports: [FormsModule,
        PrimengLibraryModule], exports: [OverrideRadioButtonLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverrideRadioButtonLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [OverrideRadioButtonLibraryComponent],
                imports: [
                    FormsModule,
                    PrimengLibraryModule
                ],
                exports: [OverrideRadioButtonLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of override-radio-button-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OverrideRadioButtonLibraryComponent, OverrideRadioButtonLibraryModule, OverrideRadioButtonLibraryService };
//# sourceMappingURL=override-radio-button-library.js.map
